<div class="modal-header border-0">
  <div>
    <p class="fs-20 fw-800 color-gray-950 mb-0">{{'agenda.availability_title'|translate}}</p>
    <p class="fs-normal fw-400 color-gray-400 mb-0">{{'agenda.availability_desc'|translate}}</p>
  </div>
  <a class="clickable color-gray-400" (click)="modal.dismiss()" [ngbTooltip]="'buttons.close'|translate" container="body"><i class="bi bi-x-lg"></i></a>
</div>

<div class="modal-body pt-0">

  <div class="day-row py-3" *ngFor="let day of days">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <p class="fs-normal fw-800 color-gray-950 mb-0">{{day.titleKey|translate}}</p>
      <a class="fs-normal fw-500 color-brand-primary-700 clickable" (click)="addSlot(day)">
        {{'agenda.add_slot'|translate}}
      </a>
    </div>

    <p class="fs-normal fw-400 color-gray-400 mb-0" *ngIf="!day.slots.length">{{'agenda.day_closed'|translate}}</p>

    <div class="row align-items-center mb-2" *ngFor="let slot of day.slots; let i = index">
      <div class="col-5">
        <app-gray-select-input
          [items]="timeOptions" bindLabel="name" bindValue="id" [clearable]="false"
          [value]="slot.startTime" (changed)="slot.startTime = $event"></app-gray-select-input>
      </div>
      <div class="col-5">
        <app-gray-select-input
          [items]="timeOptions" bindLabel="name" bindValue="id" [clearable]="false"
          [value]="slot.endTime" (changed)="slot.endTime = $event"></app-gray-select-input>
      </div>
      <div class="col-2 text-end">
        <a class="clickable color-danger" (click)="removeSlot(day, i)"
           [ngbTooltip]="'buttons.remove'|translate" container="body"><i class="bi bi-trash"></i></a>
      </div>
    </div>
  </div>

  <div class="stranded-box p-3 mt-3" *ngIf="strandedAppointments().length">
    <p class="fs-normal fw-800 color-gray-950 mb-1">{{'agenda.stranded_title'|translate}}</p>
    <p class="fs-normal fw-400 color-gray-400 mb-2">{{'agenda.stranded_desc'|translate}}</p>
    <p class="fs-normal fw-500 color-gray-950 mb-1" *ngFor="let item of strandedAppointments()">
      {{item.startsAt|date:'d MMMM, HH:mm'}} · {{item.student?.name}} · {{item.title}}
    </p>
  </div>

  <div class="form-errors mt-3" *ngIf="errKey || validationErrorKey()">
    <p>{{(errKey || validationErrorKey())|translate}}</p>
  </div>

  <div class="row mt-4">
    <div class="col-6">
      <app-gray-button
        type="button" color="stroke-gray" [weight]="500" customClass="fs-normal" [text]="'buttons.give_up'|translate"
        (click)="modal.dismiss()"></app-gray-button>
    </div>
    <div class="col-6">
      <app-gray-button
        type="button" color="primary" [weight]="500" customClass="fs-normal" [isLoading]="isLoading" [disabled]="!canSave()"
        [text]="'buttons.save'|translate" (click)="onSubmit()"></app-gray-button>
    </div>
  </div>

</div>
